module.exports = __webpack_public_path__ + "img/news9-4.08864852.png";